import { useMemo } from 'react';
import { useTasks, useCatalogs } from '@/hooks/useTasks';
import { useAppStore } from '@/store/appStore';
import { applyFilters } from '@/components/filters/FilterPanel';
import { TaskTable } from './TaskTable';

export function TableView() {
  const search = useAppStore((s) => s.search);
  const filters = useAppStore((s) => s.filters);
  const selectTask = useAppStore((s) => s.selectTask);
  const selectedId = useAppStore((s) => s.selectedTaskId);
  const { data: tasks = [], isLoading } = useTasks('status', search);
  const { data: catalogs } = useCatalogs();

  const filteredTasks = useMemo(
    () => applyFilters(tasks, filters),
    [tasks, filters],
  );

  if (isLoading) {
    return (
      <div className="p-8 text-center" style={{ color: '#747B86' }}>
        Cargando...
      </div>
    );
  }

  return (
    <TaskTable
      tasks={filteredTasks}
      selectedId={selectedId}
      onRowClick={(t) => selectTask(t.idTareaArq)}
      sprints={catalogs?.sprints ?? []}
    />
  );
}